import { notification, Select } from "antd";

import React, { useCallback, useEffect, useRef, useState } from "react";
import TableXuatKhoList from "./TableXuatKhoList";
import ModalXuatKho from "./ModalXuatKho";
import { useDispatch, useSelector } from "react-redux";
import { getDSNhapXuat } from "store/slices/sale/nhapxuatSlice";
import MeditechTablePage, { FilterComponent } from "components/table-layout";
import { SystemButtonSource } from "constants";
import DocumentViewer from "constants/DocumentViewer";
import moment from "moment";
import { getDmKk } from "store/slices/sale/danhmucSlice";
import KhNccSelect from "views/app-views/common/khachHangNCC";
import { getCateDinhKhoan } from "store/slices/finance/dinhKhoanCategorySlice";
import { getListDonViXuatHDDT } from "store/slices/sale/nhapkhoSlice";
import ModelCopyPhieuXuat from "./copyPhieuXuatThueSangNoiBo";
import { useLocation } from "react-router-dom";

const initSearch = {
  startDate: moment().startOf("month"),
  endDate: moment().endOf("month"),
  searchText: null,
  loai: -1,
  luanchuyen: false,
  makk: null,
  makknhan: null,
  branchId: null,
};
export const initXuatKhoCt = {
  action: "initial",
  isRequired: true,
};
const XuatKhoList = ({ queryId, openModalDetail }) => {
  const dispatch = useDispatch();
  const [visibleModal, setVisibleModal] = useState(false);
  const { permitList, profile } = useSelector((state) => state.auth);
  const [xuatKhoId, setXuatKhoId] = useState(null);
  const [maKkxuat, setMaKkxuat] = useState(null);
  const [chinhanhid, setChinhanhid] = useState(null);
  const [ngayxuat, setNgayxuat] = useState(null);
  const [isprinter, setIsPrinter] = useState(false);
  const [printData, setPrintData] = useState({});
  const [idPhieu, setIdPhieu] = useState(null);
  const [api, contextHolder] = notification.useNotification();
  const { dmKkList } = useSelector((state) => state.danhMucSale);
  const isThue = useLocation().pathname.includes("thue");
  const { ListDonViXuatHDDT } = useSelector((state) => state.nhapKhoSale);
  const [isVisibleCopy, setIsVisibleCopy] = useState(false);
  const [record, setRecord] = useState({});

  const openNotification = (type, placement, message) => {
    api[type]({
      message: message,
      placement,
    });
  };
  const searchFormRef = useRef({ ...initSearch });
  const [searchFormData, setSearchFormData] = useState(searchFormRef.current);
  const { nhapXuatList, loading, nhapXuatDetail } = useSelector(
    (state) => state.nhapXuatSale
  );
  const { xuatKhoCTList } = useSelector((state) => state.xuatKhoSale);
  useEffect(() => {
    if (openModalDetail) {
      setVisibleModal(openModalDetail);
      setIdPhieu(queryId);
    }
  }, [queryId, openModalDetail]);

  const reloadData = useCallback(() => {
    searchFormRef.current = { ...searchFormRef.current, isThue };
    dispatch(getDSNhapXuat(searchFormRef.current));
  }, [dispatch, isThue]);

  useEffect(() => {
    dispatch(getDmKk());
    dispatch(getCateDinhKhoan());
    dispatch(getListDonViXuatHDDT());
    reloadData();
  }, [dispatch, isThue, reloadData]);

  const searchHandle = (dataSearch) => {
    searchFormRef.current = { ...searchFormRef.current, ...dataSearch };
    setSearchFormData({ ...searchFormRef.current });
    reloadData();
  };
  const onRenderSearchView = () => {
    return (
      <FilterComponent
        datasource={searchFormData}
        onSearchImmediate={searchHandle}
        renderInputSearch
        renderDatePicker
      >
        <Select
          key="makk"
          data-field="makk"
          style={{ width: "100%", minWidth: 280 }}
          placeholder="Kho xuất"
          options={dmKkList?.filter((x) => x.maloai === 1)}
          allowClear
          showSearch
          optionFilterProp="children"
          filterOption={(input, option) =>
            (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
          }
        />
        <KhNccSelect
          style={{ width: "100%", minWidth: 280 }}
          key="makknhan"
          data-field="makknhan"
          placeholder="Đơn vị nhận"
          allowClear
        />
        <Select
          key="branchId"
          data-field="branchId"
          style={{ width: "100%", minWidth: 280 }}
          placeholder="Đơn vị"
          allowClear
          filterOption={(input, option) =>
            (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
          }
          options={profile?.branchInfos
            .filter((f) => ListDonViXuatHDDT.includes(f.branchId))
            .map((m) => ({
              value: m.branchId,
              label: m.branchName,
            }))}
        />
        {/* <Select
          key="makknhan"
          data-field="makknhan"
          style={{ width: "100%", minWidth: 280 }}
          placeholder="Đơn vị nhận"
          options={dmKkList}
          allowClear
          showSearch
          optionFilterProp="children"
          filterOption={(input, option) =>
            (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
          }
        /> */}
      </FilterComponent>
    );
  };

  const onDeleteHandler = (id) => {};

  const onOpenDetailHandler = (id) => {
    //setDoanKhamId(id);
    setVisibleModal(true);
  };

  const getRightButton = (isLocked) => {
    const arr = [];
    if (isLocked) {
      arr.push({
        keyName: SystemButtonSource.addBtn,
        title: "Thêm",
        showMore: false,
        // disable: !allowAddNew,
      });
    }
    return arr;
  };

  const onRightTopBtnHandler = (key) => {
    switch (key) {
      case SystemButtonSource.addBtn:
        setVisibleModal((prev) => !prev);
        break;
      default:
        break;
    }
  };
  return (
    <>
      {contextHolder}
      <MeditechTablePage
        tableTitle={`Quản lý xuất kho ${isThue ? "thuế" : "nội bộ"}`}
        btnHeaderRightSource={getRightButton(true)}
        btnHeaderRightSourceHandle={onRightTopBtnHandler}
        onRenderSearchView={onRenderSearchView}
      >
        <TableXuatKhoList
          loading={loading}
          setXuatKhoId={setXuatKhoId}
          nhapXuatList={nhapXuatList}
          reloadData={() => reloadData()}
          setVisibleModal={setVisibleModal}
          visibleModal={visibleModal}
          permitList={permitList}
          setMaKkxuat={setMaKkxuat}
          setNgayxuat={setNgayxuat}
          onOpenDetail={onOpenDetailHandler}
          onDelete={onDeleteHandler}
          setIsPrinter={setIsPrinter}
          setPrintData={setPrintData}
          setRecord={setRecord}
          isThue={isThue}
          setIsVisibleCopy={setIsVisibleCopy}
          setChinhanhid={setChinhanhid}
        />
      </MeditechTablePage>
      <ModalXuatKho
        visibleModal={visibleModal}
        loading={false}
        setVisibleModal={setVisibleModal}
        setXuatKhoId={setXuatKhoId}
        xuatKhoId={xuatKhoId}
        nhapXuatDetail={nhapXuatDetail}
        reloadData={() => reloadData()}
        permitList={permitList}
        xuatKhoCTList={xuatKhoCTList}
        setMaKkxuat={setMaKkxuat}
        maKkxuat={maKkxuat}
        setNgayxuat={setNgayxuat}
        ngayxuat={ngayxuat}
        idPhieu={idPhieu}
        setIdPhieu={setIdPhieu}
        openNotification={openNotification}
        dmKkList={dmKkList}
        setIsPrinter={setIsPrinter}
        setPrintData={setPrintData}
        isThue={isThue}
        profile={profile}
        ListDonViXuatHDDT={ListDonViXuatHDDT}
        chinhanhid={chinhanhid}
        setChinhanhid={setChinhanhid}
      />
      <DocumentViewer
        openModel={isprinter}
        setIsPrinter={setIsPrinter}
        soPhieu={printData.sophieu}
        idPhieu={printData.idphieu}
        setPrintData={setPrintData}
        param={{
          manx: (printData.manx || 0).toString(),
          tenkkgiao: (printData.tenkkgiao || "").toString(),
          tenkknhan: (printData.tenkknhan || "").toString(),
          ct: "2",
        }}
        tenMauIn={"NhapXuat.rptPhieuXuatKho"}
        loaiPhieu={"NhapXuat"}
        tieuDe={`In phiếu xuất ${printData.sophieu}`}
      />
      {isVisibleCopy && (
        <ModelCopyPhieuXuat
          isVisibleCopy={isVisibleCopy}
          setIsVisibleCopy={setIsVisibleCopy}
          record={record}
        />
      )}
    </>
  );
};

export default XuatKhoList;
